import React, { useState, useEffect } from "react";
import * as actionCreators from "./../../actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Alert, Fade } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { strToDate, eliminarDiacriticosEsNum } from "../../utilities";
import Inputs from "./../../Components/Inputs";

function BeneficiaryData({ codpmpol, saveBeneficiary, relationship }) {
  const [mensaje, setMensaje] = useState(null);
  const [error, setError] = useState(false);
  const [legal, setLegal] = useState(true);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const initialState = {
    dni: "",
    phone: "",
    name: "",
    email: "",
    lastname: "",
    percent: "",
    birthday: "",
    order: data.length + 1,
    family: "",
  };

  const addBeneficiary = () => setData((prev) => [...prev, initialState]);

  const handleChangeAdd = () => {
    setLegal(false);
    if (data.length === 0) addBeneficiary();
  };

  const handleChangeLegal = () => {
    setLegal(true);
    setData([]);
  };
  const validEmail = (mail) =>
    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail);

  const normalizeDNI = (e) =>
    (e.target.value = e.target.value.replace(/\D/g, "").substr(0, 8));

  const handleChange = (name, value, ix) => {
    const newArr = data.map((item, i) => {
      if (i === ix) {
        return { ...item, [name]: value };
      } else {
        return item;
      }
    });
    setData(newArr);
  };

  const verifyForm = (ix, isNew) => {
    if (!data[ix].dni) {
      setMensaje("Revise el DNI");
      return false;
    }
    if (
      !data[ix].phone ||
      data[ix].phone[0] === "0" ||
      data[ix].phone.length !== 10
    ) {
      setMensaje("Revise el teléfono (sin 0 y sin 15)");
      return false;
    }
    if (data[ix].name.length <= 2) {
      setMensaje("Revise el nombre");
      return false;
    }
    if (!data[ix].email || !validEmail(data[ix].email)) {
      setMensaje("Revise el email");
      return false;
    }
    if (data[ix].lastname.length <= 2) {
      setMensaje("Revise el apellido");
      return false;
    }
    if (!data[ix].percent) {
      setMensaje("Revise el porcentaje");
      return false;
    }
    if (!data[ix].birthday) {
      setMensaje("Revise la fecha de nacimiento");
      return false;
    }
    if (!data[ix].order) {
      setMensaje("Revise el orden de prioridad");
      return false;
    }
    if (!data[ix].family) {
      setMensaje("Revise el parentesco");
      return false;
    }
    if (
      !isNew &&
      data.reduce((acu, res) => {
        return Number(acu) + Number(res.percent);
      }, 0) !== 100
    ) {
      setMensaje("Las sumas del porcentaje deben dar 100");
      return false;
    }
    return true;
  };

  const newBeneficiary = (isNew) => {
    if (verifyForm(data.length - 1, isNew)) {
      setError(false);
      addBeneficiary();
    } else {
      setMensaje((prev) => prev + " antes de agregar un nuevo beneficiario.");
      setError(true);
    }
  };

  const handleSubmit = () => {
    if (legal || verifyForm(data.length - 1)) {
      setError(false);
      if (legal) {
        saveBeneficiary(legal, "", codpmpol);
      } else {
        data.forEach((beneficiary) =>
          saveBeneficiary(
            legal,
            {
              ...beneficiary,
              birthday: strToDate(beneficiary.birthday),
            },
            codpmpol,
            data.length
          )
        );
      }
      navigate("/qs/payMethod");
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    codpmpol === "" && navigate("/");
  }, []);

  return (
    <Fade appear in>
      <div className={`qs ${legal && "qsmargin"}`}>
        <div className="container max-shadow">
          <div className='d-flex flex-column m-0 mx-0 mb-4 scroll-off'>
            <h1 className='text-start mx-0 mt-3 fs-5 color-title-blue'>PEDIDO DE COBERTURA / DATOS BENEFICIARIO</h1>
            <p className='m-0 fw-semibold color-title-blue'>Presupuesto n° {codpmpol}</p>
          </div>
          <div className="qs-inputs row row-cols-2">
            <div className="benef" onClick={handleChangeLegal}>
              <input type={"radio"} name="legacy" checked={legal} />
              <h3 className="color-title-blue">Herederos legales</h3>
            </div>
            <div className="benef" onClick={handleChangeAdd}>
              <input type={"radio"} name="legacy" checked={!legal} />
              <h3 className="color-title-blue">Agregar beneficiarios</h3>
            </div>
            {!legal && (
              <>
                {data.map((item, ix) => (
                  <>
                    <Inputs
                      title={"Nro. DNI"}
                      name={"dni"}
                      value={data[ix].dni}
                      change={(e) => {
                        normalizeDNI(e);
                        handleChange(e.target.name, e.target.value, ix);
                      }}
                    />
                    <Inputs
                      title={"Teléfono"}
                      name={"phone"}
                      type={"number"}
                      value={data[ix].phone}
                      change={(e) =>
                        handleChange(e.target.name, e.target.value, ix)
                      }
                    />
                    <Inputs
                      title={"Nombre"}
                      name={"name"}
                      value={eliminarDiacriticosEsNum(data[ix].name)}
                      change={(e) =>
                        handleChange(e.target.name, e.target.value, ix)
                      }
                    />
                    <Inputs
                      title={"E-mail"}
                      name={"email"}
                      value={data[ix].email}
                      change={(e) =>
                        handleChange(e.target.name, e.target.value, ix)
                      }
                    />
                    <Inputs
                      title={"Apellido"}
                      name={"lastname"}
                      value={eliminarDiacriticosEsNum(data[ix].lastname)}
                      change={(e) =>
                        handleChange(e.target.name, e.target.value, ix)
                      }
                    />
                    <Inputs
                      title={"Porcentaje"}
                      name={"percent"}
                      type={"number"}
                      value={data[ix].percent}
                      change={(e) =>
                        handleChange(e.target.name, e.target.value, ix)
                      }
                    />
                    <Inputs
                      title={"Fecha de Nacimiento"}
                      name={"birthday"}
                      type={"date"}
                      value={data[ix].birthday}
                      change={(date) => handleChange("birthday", date, ix)}
                    />
                    <Inputs
                      title={"Orden"}
                      name={"order"}
                      type={"number"}
                      value={data[ix].order}
                      change={(e) =>
                        handleChange(e.target.name, e.target.value, ix)
                      }
                    />
                    <Inputs
                      title={"Parentesco"}
                      name={"family"}
                      type={"select"}
                      options={relationship}
                      value={data[ix].family}
                      change={(e) => handleChange("family", e.value, ix)}
                    />
                    <div></div>
                  </>
                ))}
                <div></div>
                <Inputs
                  type={"button"}
                  title={"Agregar beneficiario"}
                  onClick={() => newBeneficiary(true)}
                  className={"addBeneficiary"}
                />
              </>
            )}
          </div>
          {error && (
            <Alert className="mt-2" variant="danger">
              {mensaje}
            </Alert>
          )}
          <div className="row flexend">
            <div className="col-sm-6 col-lg-2 offset-lg-5">
              <Inputs
                type={"button"}
                title="Continuar"
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}

function mapStateToProps(state) {
  return {
    codpmpol: state.mainReducer.codpmpol,
    beneficiaryData: state.mainReducer.beneficiaryData,
    relationship: state.mainReducer.relationship,
  };
}

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaryData);
